import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppPermissionsGuard } from './core/auth/guards/app-permissions/app-permissions.guard';
import { AuthGuard } from './core/auth/guards/authenticate/auth.guard';
import { ClientGuard } from './core/auth/guards/client/client.guard';
import { LayoutComponent } from './core/layout/layout/layout.component';
import { PageLayoutComponent } from './core/layout/page-layout/page-layout.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'info-locations',
    loadChildren: () =>
      import('./modules/info-locations/info-locations.module').then(
        m => m.InfoLocationsModule
      )
  },

  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard, ClientGuard],
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./modules/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'exchange',
        loadChildren: () =>
          import('./modules/exchange-rates/exchange-rates.module').then(
            m => m.ExchangeRatesModule
          )
      },
      {
        path: 'locations',
        loadChildren: () =>
          import('./modules/locations/locations.module').then(
            m => m.LocationsModule
          )
      },
      {
        path: 'crm',
        loadChildren: () =>
          import('./modules/crm/crm.module').then(m => m.CrmModule)
      },
      {
        path: '',
        component: PageLayoutComponent,
        children: [
          {
            path: 'accounts',
            canActivate: [AppPermissionsGuard],
            data: { permission: 'VIEW_ACCOUNTS' },
            loadChildren: () =>
              import('./modules/accounts/accounts.module').then(
                m => m.AccountsModule
              )
          },
          {
            path: 'savings',
            loadChildren: () =>
              import('./modules/savings/savings.module').then(
                m => m.SavingsModule
              )
          },
          {
            path: 'deposits',
            loadChildren: () =>
              import('./modules/deposits/deposits.module').then(
                m => m.DepositsModule
              )
          },

          {
            path: 'loans',
            loadChildren: () =>
              import('./modules/loans/loans.module').then(m => m.LoansModule)
          },
          {
            path: 'cards',
            canActivate: [AppPermissionsGuard],
            data: { permission: 'VIEW_CARDS' },
            loadChildren: () =>
              import('./modules/cards/cards.module').then(m => m.CardsModule)
          },
          {
            path: 'orders',
            loadChildren: () =>
              import('./modules/orders/orders.module').then(m => m.OrdersModule)
          },
          {
            path: 'payments',
            canActivate: [AppPermissionsGuard],
            data: { permission: 'VIEW_PAYMENTS' },
            loadChildren: () =>
              import('./modules/payments/payments.module').then(
                m => m.PaymentsModule
              )
          },
          {
            path: 'sepa',
            loadChildren: () =>
              import('./modules/sepa/sepa.module').then(m => m.SepaModule)
          },
          {
            path: 'profile',
            loadChildren: () =>
              import('./modules/profile/profile.module').then(
                m => m.ProfileModule
              )
          },
          {
            path: 'messages',
            canActivate: [AppPermissionsGuard],
            data: { permission: 'VIEW_MESSAGES' },
            loadChildren: () =>
              import('./modules/messages/messages.module').then(
                m => m.MessagesModule
              )
          }
        ]
      }
    ]
  },
  {
    path: 'info-locations',
    loadChildren: () =>
      import('./modules/info-locations/info-locations.module').then(
        m => m.InfoLocationsModule
      )
  },

  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
